export default "__VITE_ASSET__0d79499a__"